.avatar-container {
  margin: 0 auto 3.6rem;
  position: relative;
}

.button-group-container {
  display: flex;
  flex-direction: row;
  justify-content: end;
  border-top: 1px solid #31343c;
  padding-top: 2rem;
  width: 100%;
  max-width: 94.4rem;
}

.field-container {
  margin-bottom: 2.4rem;
}
